import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  OnInit,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { Router } from '@angular/router';
import { PickupService } from 'src/app/services/pickup.service';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { UpdateService } from 'src/app/services/update.service';
import { EncuestaComponent } from 'src/app/modal/encuesta/encuesta.component';
import { MatDialog } from '@angular/material/dialog';
import { QueueService } from '../../services/queue.service';
import { Pedido } from 'src/app/interfaces/Pedido';

@Component({
  selector: 'app-inicio',
  templateUrl: './inicio.component.html',
  styleUrls: ['./inicio.component.scss'],
})
export class InicioComponent implements OnInit, AfterViewInit {
  items = Array.from({ length: 200000 }).map((_, i) => `Item #${i}`);

  public mensaje: string = '';
  public panelOpenState = true;

  @ViewChildren(CdkVirtualScrollViewport) viewPort:
    | QueryList<CdkVirtualScrollViewport>
    | undefined;

  constructor(
    private chdtRef: ChangeDetectorRef,
    private router: Router,
    public dialog: MatDialog,
    public pickupService: PickupService,
    public utilityService: UtilitiesService,
    private updateService: UpdateService,
    public queueService: QueueService
  ) {}

  async forceSync() {
    this.pickupService.programados_page = 1;
    await this.pickupService.updateData();
    this.chdtRef.detectChanges();
  }

  ngOnInit() {
    this.updateService.checkForUpdates();

    if (this.pickupService.usuario.id === -1) {
      this.router.navigate(['/login']);
      return;
    }

    this.pickupService.getEncuesta().then((data: any) => {
      this.pickupService.grupoEncuesta = data;

      if (data == 0) {
        console.log(data);
        const modal = this.dialog.open(EncuestaComponent, {
          height: this.utilityService.modal_height + 'px',
          width: '100%',
          maxHeight: window.screen.height + 'px',
          maxWidth: window.screen.width + 'px',
          data: {
            preguntas: data,
          },
        });
      }
    });
    console.log(this.pickupService.usuario);
  }

  async ngAfterViewInit() {
    await this.forceSync();
    this.pickupService.pedidosProgramadosFiltrados =
      this.pickupService.pedidosProgramados;
  }

  async goOpciones(item: Pedido) {
    this.pickupService.detenerSonido();
    const queueData = this.queueService.current_bineo.get(item.sg123);
    if (queueData && queueData.length) {
      item.bultos = item.bultos.map((bulto) => {
        const colaBineo = queueData.find((cola) => cola.id === bulto.id);
        if (colaBineo) {
          bulto.ubicacion = colaBineo.ubicacion ?? undefined;
          bulto.enCola = true;
        }
        return bulto;
      });
    }
    this.pickupService.pedidoActivo = item;
    sessionStorage.setItem('pedidoActivo', JSON.stringify(item));
    this.router.navigate(['/opciones']);
  }

  async recargar() {
    await this.forceSync();
    this.pickupService.pedidosProgramadosFiltrados =
      this.pickupService.pedidosProgramados;
  }

  ir_inicio() {
    this.viewPort?.toArray().forEach((el) => el.scrollToIndex(2, 'smooth'));
  }

  buscarProgramados(event: Event) {
    this.pickupService.filtrarPedidosrogramados();

    if (!this.pickupService.pedidosProgramadosFiltrados.length)
      this.gotoBuscar();
  }

  gotoColaEnvio() {
    this.router.navigate(['/colaenvio']);
  }

  borrarBusqueda(event: Event) {
    if (!(this.pickupService.inputBuscar.length > 0)) {
      this.pickupService.pedidosProgramadosFiltrados =
        this.pickupService.pedidosProgramados;
    }
  }

  limpiarBusqueda() {
    this.pickupService.inputBuscar = '';
    this.pickupService.pedidosProgramadosFiltrados =
      this.pickupService.pedidosProgramados;
  }

  gotoBuscar() {
    this.utilityService.changeDrawerState(false);
    this.router.navigate(['/buscar'], { queryParams: { paramBuscar: 1 } });
  }
}
